import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Form } from 'react-final-form';

import SvgOpenExternal from '../svg/OpenExternal';
import { Link } from 'react-router-dom';
import Table from '../shared/table/Table';
import { selectorTypes } from '../shared/table/TableRow';
import {
  firstNameText,
  lastNameText,
  usernameText,
  emailText,
  phoneText,
  // massnotificationText,
  activeUnitText,
} from '../shared/SharedInternationalizations';
import LoadingSpinner from '../shared/LoadingSpinner';
import UserQuickActionsMenu from './UserQuickActionsMenu';

export function UnconnectedUserListTable(props) {
  const { usersArray, unitsObj, currentLocation } = props;
  const userStatusObj = props.userStatuses;


  // const location = props.location || { location: '/users/', search: '' };
  // const currentLocation = location.pathname + location.search;

  /**
   * Function to set the search value for active filtering for users
   * @param {object} event - The event from typing in the value to the search bar
   * @fires setUsersFilter - Updates local state with the value typed into the search bar
   */

  const tableHeadings = [
    {
      isSortable: false,
      display: '',
    },
    {
      isSortable: true,
      sortBy: 'lastName',
      display: lastNameText,
    },
    {
      isSortable: true,
      sortBy: 'firstName',
      display: firstNameText,
    },
    {
      isSortable: true,
      sortBy: 'username',
      display: usernameText,
    },
    {
      isSortable: true,
      sortBy: 'email',
      display: emailText,
    },
    {
      isSortable: true,
      sortBy: 'phone',
      display: phoneText,
    },
      
    {
      isSortable: true,
      sortBy: 'activeUnit',
      display: activeUnitText,
    },
    {
      isSortable: false,
      display: (
        <FormattedMessage
          id="users.linksColumnHeader"
          defaultMessage="Links"
          description="Links column header for user row view">
          {(txt) => <span className="text-medium text-regular">{txt}</span>}
        </FormattedMessage>
      ),
    },
    {
      isSortable: false,
      display: '',
    },
    {
      isSortable: true,
      sortBy: 'status',
      display: 'Status',
    },
  ];

  /**
   * Function to generate the users table
   * @returns {object} - The table of users
   */
  const usersTable = (props) => {
    // map over the users and put into the format that is required for the table component
    const formattedUsers = usersArray.map((user) => {
      let activeUnit = { name: '' };
      if (user.active_unit) {
        if (unitsObj[user.active_unit]) {
          activeUnit = unitsObj[user.active_unit];
        }
      }
      // Create the "full view" button that will be used to open the full user view
      const activeUnitLink = (
        <Link
          to={`/units/${user.active_unit}/view/`}
          className="text-small link-text"
          data-test="user-row-active-unit-link">
          {activeUnit.name} <SvgOpenExternal />
        </Link>
      );

      // Create the "full view" button that will be used to open the full user view
      const fullView = (
        <FormattedMessage
          id="userList.fullViewButton"
          defaultMessage="Full View"
          description="Button to view full user info on user card component"
          data-test="user-row-full-view-translation-link">
          {(txt) => (
            <Link
              to={`${user.id}/view`}
              state={{
                previous: currentLocation,
              }}
              className="text-small link-text"
              data-test="user-row-full-view-link">
              {txt} <SvgOpenExternal />
            </Link>
          )}
        </FormattedMessage>
      );
      const lastName = user.last_name.toUpperCase() || '';
      const firstName = user.first_name.toUpperCase() || '';
      const username = user.username || '';
      const email = user.email || '';
      const phone = user.phone || '';
      
   
     let status=user.status?userStatusObj[user.status].description:'';
     
      return {
        selector: {
          sortBy: user.id,
          display: user.id,
        },
        lastName: {
          sortBy: lastName,
          display: `${user.last_name} ${user.suffix ? `"${user.suffix}"` : ''}`,
        },
        firstName: {
          sortBy: firstName,
          display: `${user.first_name} ${
            user.preferred_name ? `"${user.preferred_name}"` : ''
          }`,
        },
        //Display username on list that doesn't start with gen_
        username: {
          sortBy: username,
          display: !user.username.startsWith('gen_') ? user.username : null,
        },
        email: {
          sortBy: email,
          display: <a href={`mailto:${user.email}`}>{user.email}</a>,
        },
        phone: {
          sortBy: phone,
          display: <a href={`tel:${user.phone}`}>{user.phone}</a>,
        },

        
        activeUnit: {
          sortBy: activeUnit.name.toUpperCase(),
          display: user.active_unit ? activeUnitLink : '',
        },
        links: {
          sortBy: '',
          display: fullView,
        },
        menu: {
          sortBy: '',

          display: (
            <UserQuickActionsMenu
              user={user}
              currentLocation={currentLocation}
            />
          ),
        },
        status: {
        sortBy: status,
        display:status
        },
      };
    });
     
    // generates the actual table
    const table = (
      <Table
        hasTableHead={true}
        hasSelector={false}
        tableHeadings={tableHeadings}
        selectorName="usersId"
        selectorParamValue="id"
        sortParam="lastName"
        tableData={formattedUsers}
        selectorType={selectorTypes.checkbox}
        tableStyles="table-layout__10-column"
        data-test="user-table"
      />
    );
    return table;
  };

  function onSubmit() {}
  function tableDisplay() {
    if (usersArray.length > 0 || props.apiSpinner.usersReturned) {
      return (
        <Form
          data-test="user-list-form"
          onSubmit={onSubmit}
          render={({
            handleSubmit,
            pristine,
            invalid,
            reset,
            submitting,
            values,
          }) => (
            <form
              onSubmit={handleSubmit}
              className="add-unit-form__form-container">
              {usersTable()}
            </form>
          )}
        />
      );
    } else {
      return (
        <div className="loading-spinner__user-list-container">
          <LoadingSpinner />
        </div>
      );
    }
  }

  return tableDisplay();
}

const mapStateToProps = (state) => {
  return {
    unitsObj: state.units.units,
    usersObj: state.users.users,
    userStatuses: state.users.userStatuses,
  };
};

export default connect(mapStateToProps)(UnconnectedUserListTable);
